export const truncateHtml = (html, maxWords, suffix = '…') => {
  if (!html) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const body = doc.body;

  const isPlainText = !html.includes('<') || !html.includes('>') || body.children.length === 0;

  if (isPlainText) {
    const words = html.trim().split(/\s+/).filter(Boolean);
    if (words.length <= maxWords) return html;
    return words.slice(0, maxWords).join(' ') + suffix;
  }

  let remaining = maxWords;
  let truncated = false;

  function walk(node) {
    if (truncated) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const words = node.textContent.trim().split(/\s+/).filter(Boolean);

      if (words.length <= remaining) {
        remaining -= words.length;
      } else {
        node.textContent = words.slice(0, remaining).join(' ') + suffix;
        truncated = true;

        let next = node.nextSibling;
        while (next) {
          const toRemove = next;
          next = next.nextSibling;
          toRemove.parentNode.removeChild(toRemove);
        }

        let parent = node.parentNode;
        while (parent && parent !== body) {
          let sib = parent.nextSibling;
          while (sib) {
            const toRemove = sib;
            sib = sib.nextSibling;
            toRemove.parentNode.removeChild(toRemove);
          }
          parent = parent.parentNode;
        }
      }
      return;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      for (const child of Array.from(node.childNodes)) {
        if (truncated) break;
        walk(child);
      }
    }
  }

  Array.from(body.childNodes).forEach(walk);
  return body.innerHTML;
};
